export const downloadFileAsJSBlob = (fileContentBlob: Blob, fileName: string): void => {
  const a = document.createElement('a');
  a.download = fileName;
  a.href = window.URL.createObjectURL(fileContentBlob);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
